/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSetZeroDayAlertPublishedRequest
 */
export interface ControlSetZeroDayAlertPublishedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ControlSetZeroDayAlertPublishedRequest
     */
    published: boolean;
}

/**
 * Check if a given object implements the ControlSetZeroDayAlertPublishedRequest interface.
 */
export function instanceOfControlSetZeroDayAlertPublishedRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "published" in value;

    return isInstance;
}

export function ControlSetZeroDayAlertPublishedRequestFromJSON(json: any): ControlSetZeroDayAlertPublishedRequest {
    return ControlSetZeroDayAlertPublishedRequestFromJSONTyped(json, false);
}

export function ControlSetZeroDayAlertPublishedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSetZeroDayAlertPublishedRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'published': json['published'],
    };
}

export function ControlSetZeroDayAlertPublishedRequestToJSON(value?: ControlSetZeroDayAlertPublishedRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'published': value.published,
    };
}

